module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-list"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec50786e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/list/list.vue
// module id = 477
// module chunks = 1